import React from 'react';
import './Footer.css';
import FooterBg from '../assets/Footer.svg';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <div
      className="footerContainer"
      style={{
        backgroundImage: `url(${FooterBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center top',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div className="footer-content">
        <div className="footer-left">
          <div className="footer-column">
            <p className="section-header">ABOUT US</p>
            <Link to="/TexasIslamicConference" className="footer-link">
              Voices Of Virtue
            </Link>
            <Link to="/MeetTheTeam" className="footer-link">
              Meet the Team
            </Link>
            <Link to="/Sponsors" className="footer-link">
              Sponsors
            </Link>
            <Link to="/ContactUs" className="contact-button">Contact Us</Link>
          </div>

          <div className="footer-column">
            <p className="section-header">PARTICIPATE</p>
            <Link to="/Registration" className="footer-link">
              Registration
            </Link>
            <Link to="/Donations" className="footer-link">
              Donations
            </Link>
            <Link to="/ProgramDetails" className="footer-link">
              Program Details
            </Link>
            <Link to="/VisitingBCS" className="footer-link">
              Visiting CSTAT
            </Link>
          </div>
        </div>

        <div className="footer-right">
          <div className="title-section">
            <h1 className="script-title">Texas Islamic Conference</h1>
            <h2 className="main-title">VOICES OF VIRTUE</h2>
          </div>
        </div>
      </div>
    </div>
  );
}